export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/modular_systems_booth.361a29d.svg";